module.exports = __webpack_public_path__ + "static/media/partner7.441a96e2.png";